import { HTMLAttributes, FC } from "react";
import clsx from "classnames";
import { useStyles } from "./Alert.style";
import { TypographyVariant, Typography } from "../Typography/Typography";
import { Image } from "../Image/Image";
import SuccessIconWebp from "../../assets/success.webp";

interface IAlertProps {
  classify: string;
  message: string;
}

export const Alert: FC<IAlertProps & HTMLAttributes<HTMLDivElement>> = (
  props,
) => {
  const classes = useStyles();
  const { classify, message, ...othersProps } = props;

  return (
    <div
      {...othersProps}
      className={clsx(classes.root, `s-${classify}`, props.className)}
    >
      {classify === "success" && <Image src={SuccessIconWebp} height={28} />}
      <Typography
        variant={TypographyVariant.BodyB5Bold}
        className={classes.message}
      >
        {message}
      </Typography>
    </div>
  );
};
